let cartDrawer = {
	parser:new DOMParser(),
	init:function(){
		this.main_element = document.querySelector('.cart-drawer')
		this.items_list = this.main_element.querySelector('ul');
		this.cart_counter = this.main_element.querySelector('.title .counter');
		this.note_block = this.main_element.querySelector('.note-block');

		this.upsell_block = this.main_element.querySelector('.cart-drawer-slider');

        this.total = Number(this.main_element.querySelector('.total-price').dataset.value);
        this.applied_discounts = this.main_element.dataset?.discounts;
      
		//Free Shipping
		this.free_shipping_block = this.main_element.querySelector('.shipping-discount-info');


		//Item Controls
		this.items_list.addEventListener('click', e=>{
			let action;

			//Plus
			let new_quantity = false;
			if(e.target.classList.contains('plus')){
				action = 'increase'
			}

			//Minus
			if(e.target.classList.contains('minus')){
				action = 'decrease'
			}

			//Remove
			if(e.target.classList.contains('remove')){
				action = 'delete'
			}			


			if(action){
				let item_block = e.target.closest('li');
				let id = item_block.dataset.id;
				let quantity = Number(item_block.querySelector('input').value);
				
				if(action == 'delete'){
					quantity = 0;
				}
				if(action == 'decrease'){
					quantity-=1;
				}
				if(action == 'increase'){
					quantity+=1;
				}

				let data = {
					updates:{},
				}
				data.updates[id] = quantity;
				this.state_change(data, 'update');
			}
		})



		this.items_list.addEventListener('change', e=>{
			let item_block = e.target.closest('li');
			let id = item_block.dataset.id;
			let data = {
				updates:{},
			}
			data.updates[id] = e.target.value;
			this.state_change(data, 'update');
		});



		this.note_block.querySelector('.note-block-title').addEventListener('click', (e)=>{
			this.note_block.classList.toggle('active');
		})


	},


	state_change:function(data, action, callback){
		data.sections = 'cart-drawer';

		//Prevent Double Action
		if(this.main_element.classList.contains('loading')){
			return false;
		}

		//Show loading spinner
		this.main_element.classList.add('loading');

		fetch('/cart/'+action+'.js', {
		  method: 'POST',
		  headers: {
		    'Content-Type': 'application/json'
		  },
		  body: JSON.stringify(data)
		}).then(response => response.json())
		.then(data => {

			let answer = this.parser.parseFromString(data.sections['cart-drawer'], "text/html");

            this.total = Number(answer.querySelector('.total-price').dataset.value);
            this.applied_discounts = answer.querySelector('.cart-drawer').dataset?.discounts;
          
			//Cart Counter Update
			let new_cart_counter_value = answer.querySelector('.title .counter').innerHTML;


			if(new_cart_counter_value == 0){
				//Empty State
				this.main_element.classList.add('empty-state-active');
			}
			else{
				this.main_element.classList.remove('empty-state-active');
			}


			let list = answer.querySelectorAll('li');
			let price = answer.querySelector('.total-price .value').innerHTML;
			this.items_list.innerHTML ='';
			list.forEach(item=>{
				cartDrawer.items_list.appendChild(item);
			})
			this.main_element.querySelector('.total-price .value').innerHTML = price;
			
			//Free Shipping Block Update
			if(this.free_shipping_block){
				this.free_shipping_block.innerHTML = answer.querySelector('.shipping-discount-info')?.innerHTML;
			}

			//Discount


			this.cart_counter.innerHTML = new_cart_counter_value;
			this.main_element.classList.remove('loading');


			//Upsell Block
            if(this.upsell_block){
				
				$(this.upsell_block.querySelector('.items')).trigger('destroy.owl.carousel');
				this.upsell_block.querySelector('.items').innerHTML = '';
                build_upsell_block(JSON.parse(answer.getElementById("cart-upsell-data")?.textContent)?.upsell_products_raw || []);
            }

            if(callback){
              callback();
            }

			//Trigger Cart Updated event
			let update_event = new CustomEvent('cart-updated', {
			    detail: {
			    	counter:new_cart_counter_value
			    }
			});
			document.dispatchEvent(update_event)

		});
	},


	open:function(){
		this.main_element.showPopover();
	},
	close:function(){
		this.main_element.hidePopover();
	},
}

cartDrawer.init();